import React, { useRef } from 'react';
// import OrderHero from './OrderHero';
import MenuPage from './MenuPage';

const Order: React.FC = () => {
  // Create a ref to the MenuPage section
  const menuRef = useRef<HTMLDivElement | null>(null);

  // function handleScrollToMenu() {
  //   if (menuRef.current) {
  //     // Calculate the offset from the top of the viewport
  //     const elementTop = menuRef.current.getBoundingClientRect().top;
  //     // Convert 15vh to a pixel offset
  //     const headerOffset = window.innerHeight * 0.15;

  //     // The pageYOffset adds the current scroll position
  //     const scrollPosition = elementTop + window.pageYOffset - headerOffset;

  //     window.scrollTo({
  //       top: scrollPosition,
  //       behavior: 'smooth',
  //     });
  //   }
  // }

  return (
    <div className="bg-sea mt-[15vh] md:mt-0">
      {/* 1) The Hero */}
      {/* <OrderHero onScrollToMenu={handleScrollToMenu} /> */}

      <section className="py-10 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-start md:justify-center">
          {/* LEFT COLUMN: Map */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end mb-6 md:mb-0 md:mr-8">
            <div className="w-full max-w-md h-0 pb-[56.25%] relative overflow-hidden shadow-lg rounded-md">
              <iframe
                title="Santa Playa Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d414.69479720584764!2d-119.70602757994102!3d34.424443892812974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e915002cffbe2b%3A0x22db976408faf77b!2sSanta%20Playa%20Mariscos!5e0!3m2!1sen!2sus!4v1741914314252!5m2!1sen!2sus"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                className="absolute top-0 left-0 w-full h-full"
              />
            </div>
          </div>

          {/* RIGHT COLUMN: Heading & Text */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            <h2 className="text-3xl font-bold mb-4 text-white font-myriad leading-tight">
              Ordering from <br />
              <span className="font-charles text-white">
                Santa Playa Mariscos <span className="font-myriad">at</span>{' '}
                1230 State Street
              </span>
            </h2>
            <p className="text-maroon font-prosto text-2xl text-balance">
              Our flagship location in Santa Barbara, serving authentic Baja
              with a Santa Barbara twist.
            </p>
          </div>
        </div>
      </section>

      {/* 3) The actual Menu section */}
      <div ref={menuRef}>
        <MenuPage />
      </div>
    </div>
  );
};

export default Order;
